import { markdown } from 'markdown';

export default function translate(path = '', md = false, stripParagraphs = false, target = '_blank') {
	if (window.konfig && window.konfig.translations) {
		let translations = window.konfig.translations;
		let pathArr = [];

		function getTrans(path, translations) {
			let pathSlice = path.pop();
			if (translations[pathSlice]) {
				if (typeof translations[pathSlice] === 'object') {
					return getTrans(path, translations[pathSlice]);
				} else if (typeof translations[pathSlice] === 'string') {
					return translations[pathSlice];
				}
			}

			console.warn(`Localization not defined. ${pathSlice}`);
			return '';
		}

		pathArr = path.split('/');
		pathArr.reverse();

		let trans = getTrans(pathArr, translations);

		if (md) {
			const breakRegex = /<br\s*[\/]?>/gi;
			const anchorTargetRegex = /<a /gi;
			trans = trans.replace(breakRegex, '');

			trans = markdown.toHTML(trans);

			trans = trans.replace(anchorTargetRegex, `<a target="${target}" `);
		}

		if (stripParagraphs) {
			trans = trans.replace(new RegExp('<p>', 'g'), '').replace(new RegExp('</p>', 'g'), '');
		}

		return trans;
	}

	return '';
}



/** WEBPACK FOOTER **
 ** ./frontend/utils/translate.js
 **/